export const ViewWarrantyPdfPageSetup = () => {
  return (
    <style>{`
      @media print {
        @page {
          size: A4;
          margin-top: 5mm;
        }
        body {
          word-break: break-word;
          overflow: visible;
          white-space: normal;
          margin-right: 5mm;
        }
      }
    `}</style>
  )
}
